import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Pricing from "../pages/pricing/page";
import ComoFunciona from "../pages/como-funciona/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/precios",
    element: <Pricing />,
  },
  {
    path: "/como-funciona",
    element: <ComoFunciona />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
